import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import GridFormatterCommon from './grid-formatter-common';
import XMLDetailsFormatterHelper from './xmldetails-formatter-helper';
import xml2json from '../xml2json';
import LoginService from "../../services/login.service";

var composeChildTable = XMLDetailsFormatterHelper.composeChildTable;
var composeDetailList = XMLDetailsFormatterHelper.composeDetailList;
var composeEmptyTable = XMLDetailsFormatterHelper.composeEmptyTable;
var composeError = XMLDetailsFormatterHelper.composeError;
var getFormattedValue = XMLDetailsFormatterHelper.GetFormattedValue;
var getHeaders = XMLDetailsFormatterHelper.GetHeaders;
var getMetadata = XMLDetailsFormatterHelper.GetMetadata;

function XmlDetailsFormatter(params, observableOptions, dataSources) {
    var self = this;
    self.loadMode = false;
    self.observableOptions = observableOptions;
    self.gridFormatterCommon = new GridFormatterCommon();
    self.dataSources = dataSources;
    self.datapresorted = params && params.datapresorted ? params.datapresorted : false;
    self.dataprepaged = params && params.dataprepaged ? params.dataprepaged : false;
    self.observableParams = dataSources[0].observableParams;
    self.viewLevelOptions = params.viewLevelOptions || observableOptions().viewLevelOptions;
    self.observableFormattedData = ko.observable({});
    self.subscriptions = [];
}

XmlDetailsFormatter.prototype = {
    DataUpdated: function () {
        var self = this;
        self.RefreshData();
    },

    dispose: function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    },

    getObservableData: function () {
        var self = this;
        return self.observableFormattedData;
    },

    initialize: function (dataRepository, dataProvider) {
        var self = this;

        self.dataRepository = dataRepository;
        self.dataProvider = dataProvider;
        self.subscriptions.push(self.dataRepository.QueryResultDatasetDictionary.subscribe(function () {
            self.DataUpdated();
        }));
    },

    OptionsUpdated: function () {
        var self = this;
        if (self.loadMode) {
            return;
        }
        self.RefreshData();
    },

    RefreshData: function () {
        var self = this;

        if (_.isEmpty(self.observableParams())) {
            return;
        }

        self.sourceList = self.dataRepository.getDictionaryValue(
            self.dataRepository.QueryResultDatasetDictionary,
            self.observableParams()
        );

        var errMsg = self.dataRepository.getErrorValue(self.observableParams());

        if (self.sourceList !== null) {
            self.observableFormattedData(composeData(
                self.sourceList,
                self.observableOptions(),
                self.dataProvider,
                self.dataSources,
                errMsg,
                self.gridFormatterCommon)
            );
        }
    }
};

function composeData(sourcelist, options, dataProvider, dataSources, errMsg, gridFormatterCommon) {
    if (errMsg) {
        return composeError(errMsg);
    }

    if (_.isEmpty(sourcelist) || _.isEmpty(sourcelist.Table) || _.isEmpty(sourcelist.Table1)) {
        return composeEmptyTable();
    }

    var retJson = xml2json(sourcelist.Table1[0].Column1);
    var innerwidths = ko.observableArray();
    var metadata = getMetadata(sourcelist.Table[0].Column1);
    var displayDetail = _.isEmpty(options.displayDetail) ? metadata.nonIdDefaultDetailColNames : options.displayDetail;
    var queryParams = JSON.parse(dataSources[0].observableParams().paramsJson);

    var rows = composeDetailList(
        sourcelist.Table1[0].Column1,
        displayDetail,
        metadata,
        gridFormatterCommon,
        queryParams.inpStartDate,
        queryParams.inpEndDate,
        LoginService.userObject
    );

    var maxCount = rows.length;
    var innerRowDisplayIndex = 0;

    if (rows.length && rows[0]._recordCount) {
        maxCount = rows[0]._recordCount;
    }

    if (metadata.detailColsWithChild.length > 0) {
        innerRowDisplayIndex = metadata.detailColsWithChild[0].seq;
        rows = composeChildTable(
            rows,
            options,
            metadata,
            dataProvider,
            dataSources,
            innerwidths,
            gridFormatterCommon,
            LoginService.userObject
        );
    }

    var headers = getHeaders(displayDetail, metadata.detail);
    // clone to avoid mutating original
    var rowProperties = _.clone(displayDetail || metadata.nonIdDetailsColNames);

    var widths = displayDetail.map(function () {
        return (100 / (displayDetail.length || 1)) + '%';
    });

    // SmartPanels and ETL are tightly coupled in that both expect a hidden ID column. This hidden
    // column shifts the sort column indeces by 1 (since it occupies index 0).
    // TODO: In order to get rid of Object.keys usage in this scenario the contract with the ETL
    // layer needs to change to rely on sort property instead of a sort index.
    if (_.has(rows, '[0].id')) {
        headers.unshift('id');
        widths.unshift('0%');
        rowProperties.unshift('id');
    }

    var summarylist = [];

    if (retJson && retJson.summary && retJson.summary.row) {
        summarylist = retJson.summary.row;
    }

    var cells = [];

    var displaySummaryNames = options.displaySummary || getDefaultColumns(metadata.nonIdSummary) || [];
    var displaySummary = metadata.nonIdSummary.filter(function (metadataSummary) {
        return displaySummaryNames.indexOf(metadataSummary.name) >= 0;
    });

    if (summarylist && !$.isEmptyObject(summarylist)) {
        if (!displaySummaryNames || !displaySummaryNames.length) {
            displaySummaryNames = Object.keys(summarylist);
        }

        var widths2 = displaySummaryNames.map(function () {
            return (96 / displaySummaryNames.length) + '%';
        });

        cells = displaySummary.map(function (summaryItem, index) {
            var rawValue = summarylist[summaryItem.name];
            return {
                value: getFormattedValue({
                    rawValue: rawValue,
                    name: summaryItem.name,
                    columnOptions: metadata.summary,
                    useAbbreviation: false
                }, self.dataProvider),
                abbreviatedValue: getFormattedValue({
                    rawValue: rawValue,
                    name: summaryItem.name,
                    columnOptions: metadata.summary,
                    useAbbreviation: true
                }),
                footer: summaryItem.title,
                tooltip: _.isEmpty(summaryItem.tooltip) ? summaryItem.title : summaryItem.tooltip,
                cellclass: 'description-block border-right',
                cellwidthclass: 'inline-block multicellcell',
                change: null,
                changeiconclass: null,
                cellwidthpct: widths2[index]
            };
        });
    }

    return {
        cells: cells,
        colOptionsDetail: metadata.detail,
        colOptionsSummary: metadata.summary,
        displayDetail: displayDetail,
        displaySummary: displaySummaryNames,
        headers: headers,
        innerRowDisplayIndex: innerRowDisplayIndex,
        innerWidths: innerwidths,
        maxCount: maxCount,
        rowProperties: rowProperties,
        rows: rows,
        sortIndexOffset: 1,
        widths: widths
    };
}

function getDefaultColumns(columns) {
    return _.chain(columns).filter({ isDefaultColumn: true }).sortBy(['seq']).map('name').value();
}

export default XmlDetailsFormatter;
